import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CONFIGCONSTANTS } from '../../../config/app-constants';
import { OrderService } from '../../../_services/order.service';
import { Router } from '@angular/router';
import { CategoryService } from '../../../_services/category-service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../_services/loader.service';
@Component({
  selector: 'app-batch-management',
  templateUrl: './batch-management.component.html',
  styleUrls: ['./batch-management.component.scss']
})
export class BatchManagementComponent implements OnInit {
  uuid: any;
  moduleType: string;
  BatchList: any[] = [];
  // Get datatble configuration -- start
  loadingIndicator = false;
  reorderable = CONFIGCONSTANTS.datatableConfig.reorderable;
  scrollbarH = CONFIGCONSTANTS.datatableConfig.scrollbarH;
  serverSorting = CONFIGCONSTANTS.datatableConfig.serverSorting;
  serverPaging = false;
  piningRight = CONFIGCONSTANTS.datatableConfig.piningRight;
  headerHeight = CONFIGCONSTANTS.datatableConfig.headerHeight;
  footerHeight = CONFIGCONSTANTS.datatableConfig.footerHeight;
  rowHeight = CONFIGCONSTANTS.datatableConfig.rowHeight;
  limitList: any[] = CONFIGCONSTANTS.datatableConfig.limitList;
  ColumnMode = ColumnMode;
  totalReords = CONFIGCONSTANTS.datatableConfig.page.totalReords;
  pageNumber = CONFIGCONSTANTS.datatableConfig.page.pageNumber;
  size = CONFIGCONSTANTS.datatableConfig.page.size;
  dtMessages = CONFIGCONSTANTS.datatableConfig.dtMessages;
  @ViewChild(DatatableComponent, { static: false }) datatable: DatatableComponent;
  sortParam = '';
  sortOrder = '';
  // Get datatble configuration -- end
  momentDateTime24Format = CONFIGCONSTANTS.momentDateTime24Format || 'MM/DD/YYYY hh:mm:ss';
  momentDateFormat = CONFIGCONSTANTS.momentDateFormat || 'MM/DD/YYYY';
  readonly noColumnRecordText = CONFIGCONSTANTS["dataTableListing"]["columnRecordMissingText"];

  showNewRows = false;
  newRows: any[] = [];
  datePickerConfig = CONFIGCONSTANTS["datePickerConfig"];
  maxDate = new Date();
  minDate = new Date(CONFIGCONSTANTS["minYearSelectCalender"]);
  // qtyNotValid:boolean = false;
  batchNotValid:boolean = false;
  row: any;
  obj:any;
  rowAdded: boolean = false;
  qtyNotValid: boolean[] = [];
  purchasePriceNotValid: boolean[] = [];
  salePriceNotValid: boolean[] = [];
  batchNoNotValid: boolean[] = [];
  originalQty: any;
  originalDate: any;
  disableBatchField:boolean = false;

  constructor(
    private categoryService: CategoryService,
    public modalRef: BsModalRef,
    public modalRefDelete :BsModalRef,
    private router: Router,
    private modalService: BsModalService,
    private toast: ToastrService,
    private loader: LoaderService) {

  }

  ngOnInit() {
    this.getBatchViewList();
  }
  /**
   * Get status class from configuration
   * @param status Active/Inactive/Penging
   */
  public getStatusClass(status) {
    if (status) {
      return CONFIGCONSTANTS.statusClass[status];
    } else {
      return 'badge-primary';
    }
  }
  /**
   * Sort datatable fields
   * @param event event was triggered, start sort sequence
   */
  public onSort(event) {
    this.sortParam = event.sorts[0].prop;
    this.sortOrder = event.sorts[0].dir;
    this.rerender(false);
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  public setPage(pageInfo) {
    this.pageNumber = pageInfo.offset;
    this.rerender(false);
  }
  /**
   * Show number of records in datatable
   * @param value show total entries value 10,25,50,100
   */
  public changeLimit(value) {
    this.size = value;
    this.rerender(true);
    this.totalReords = this.BatchList.length;
  }
  /**
   * API call and refresh datatable value
   * @param goFirstPage set first page when param value true
   */
  private rerender(goFirstPage): void {
    if (goFirstPage) {
      this.pageNumber = 0;
    }
    this.getBatchViewList();
  }

  getBatchViewList() {
    this.loadingIndicator = true;
    this.categoryService.getBatchViewList(this.uuid,{
      start: (this.pageNumber) * (this.size),
      length: this.size,
      // sort_param: this.sortParam,
      // sort_type: this.sortOrder
    })
      .pipe(first())
      .subscribe(res => {
        this.loadingIndicator = false;
        this.BatchList = res.data.original.data;
        this.totalReords = res.data['original'].recordsTotal;
      }, error => {
        this.loadingIndicator = false;
      });
  }

  decline(): void {
    this.modalRef.hide();
  }

  declineDelete():void {
    this.modalRefDelete.hide();
  }

  addNewRow() {
    this.showNewRows = true;
    const newRow = {
      qty: "",
      batch_no: "",
      expiry_month_year: "",
      created_at: "",
      srNum: this.BatchList.length + 1, // Assign a unique srNum for the new row
      isNew: true // Flag to identify it as a new row
    };
    
    //adding new row after the last row by going to last page
    let lastPage = this.totalReords/this.size;
    this.pageNumber = Math.floor(lastPage);
    
    this.BatchList.push(newRow);
    this.updateSrNums();
    this.totalReords = this.BatchList.length;
  }
  
  // validating batch field on change 
  onBatchChange(row:any,rowIndex:number){
    if(row !== '' || row !== null){
      this.batchNoNotValid[rowIndex] = false;
    }
  }
  // validating quantity field on change 
  onQtyChange(row:any,rowIndex:number){
    if(row !== '' || row !== null){
      this.qtyNotValid[rowIndex] = false;
    }
  }


onPurchasePriceChange(value: any, rowIndex: number) {
  if (value !== '' && value !== null) {
    this.purchasePriceNotValid[rowIndex] = false;
  }
}

onSalePriceChange(value: any, rowIndex: number) {
  if (value !== '' && value !== null) {
    this.salePriceNotValid[rowIndex] = false;
  }
}




  //common function to valiadte row on both edit and save
  private validateRow(row: any, rowIndex: number): boolean {
    if (row.qty<0 || row.qty === '' || row.qty == null) {
      this.qtyNotValid[rowIndex] = true;
      this.toast.error('Please enter the quantity', 'Error');
      return false;
    } else {
      this.qtyNotValid[rowIndex] = false;
    }
  
    if (!row.batch_no) {
      this.batchNoNotValid[rowIndex] = true;
      this.toast.error('Please enter the batch number', 'Error');
      return false;
    } else {
      this.batchNoNotValid[rowIndex] = false;
    }
   
  if (row.purchase_price < 0 || row.purchase_price === '' || row.purchase_price == null) {
    this.purchasePriceNotValid[rowIndex] = true;
    this.toast.error('Please enter the purchase price', 'Error');
    return false;
  } else {
    this.purchasePriceNotValid[rowIndex] = false;
  }

  if (row.sale_price < 0 || row.sale_price === '' || row.sale_price == null) {
    this.salePriceNotValid[rowIndex] = true;
    this.toast.error('Please enter the sale price', 'Error');
    return false;
  } else {
    this.salePriceNotValid[rowIndex] = false;
  }

    row.expiry_month_year = row.expiry_month_year ? moment(row.expiry_month_year).format('YYYY-MM-DD') : '';
    
    return true;
  }

  // Save new row
  saveNewRow(row: any, rowIndex: number) {
    this.saveRow(row, rowIndex, true);
  }

  // Update existing row
  saveUpdatedRow(row: any, rowIndex: number) {
    this.saveRow(row, rowIndex, false);
  }

  saveRow(row: any, rowIndex: number, isNewRow: boolean) {
    if (!this.validateRow(row, rowIndex)) {
      return;
    }
  
    this.obj = {
      batch: row.batch_no,
      qty: row.qty.toString(),
      expiry: row.expiry_month_year,
      purchase_price: row.purchase_price,
      sales_price: row.sale_price,
      type: isNewRow ? 'Add' : 'Edit'
    };

    this.addEditBatch(row);
  }
  

  editRow(row:any,rowIndex:number){
    row.isNew = true;
    row.isEdit = true;
    row.isEditing = true;
    row.expiry_month_year = row.expiry_month_year ? moment(row.expiry_month_year).format('DD-MMM-YYYY') : '';
    this.originalQty = row.qty;
    this.originalDate = row.expiry_month_year;
    row.disableBatchField = true;
  }


  updateRow(row: any, rowIndex: number) {
    // Save the updated data and perform other actions
    row.isEdit = true;
    row.isEditing = true;
    // row.isNew = false;
    this.saveUpdatedRow(row,rowIndex);
  }
  
  cancelEditRow(row: any, rowIndex: number) {
    // Cancel the edit and revert to the original data
    row.isEdit = false;
    row.isNew = false;
    row.expiry_month_year = row.expiry_month_year ? moment(row.expiry_month_year).format('YYYY-MM-DD') : '';
    row.expiry_month_year = this.originalDate;
    row.qty = this.originalQty;
  }

  // Create helper functions to check and set error states
  private isQtyInvalid(row: any): boolean {
    return !row.qty || row.qty === '';
  }
  private isBatchNoInvalid(row: any): boolean {
    return !row.batch_no || row.batch_no === '';
  }

  addEditBatch(row:any){
    this.loadingIndicator = true;
    this.categoryService.AddEditIndividualMedicineBatch(this.obj,this.uuid)
      .pipe(first())
      .subscribe(res => {
        this.loadingIndicator = false;
        this.toast.success(res.meta.message);
        this.rowAdded = true;
        if (this.rowAdded) {
          row.isNew = false; // Mark the row as not new
          this.showNewRows = false; // Hide the new row section
          row.created_at === '' ? row.created_at = this.getCurrentDateTime() : row.created_at = row.created_at;
          // this.getBatchViewList();
        }
      }, 
      error => {
        this.loadingIndicator = false;
        const errorData = error;
        const self = this;
        if (errorData && errorData.meta) {
          if (errorData.meta.message_code === 'VALIDATION_ERROR') {
            for (const key in errorData.errors) {
              if (key) {
                self.toast.error(errorData.errors[key][0]);
              }
            }
          } else {
            self.toast.error(errorData.meta.message);
          }
        } else {
          this.toast.error('Something went wrong please try again.');
        }
      });
  }

  cancelNewRow(row:any,rowIndex:number) {
    // If you want to remove the new row entirely on cancel
    const index = this.BatchList.indexOf(row);
    if (index > -1) {
      this.BatchList.splice(index, 1);
      //resetting error state for deleted row
      this.qtyNotValid[rowIndex] = false;
      this.batchNoNotValid[rowIndex] = false;
      this.updateSrNums();
    }
    this.showNewRows = false; // Hide the new row section
    this.totalReords = this.BatchList.length;
  }

  updateSrNums() {
    for (let i = 0; i < this.BatchList.length; i++) {
      this.BatchList[i].srNum = i + 1;
    }
  }

  onBatchNoInput(event: any) {
    const inputElement = event.target as HTMLInputElement;
    const validInput = inputElement.value.replace(/[^a-zA-Z0-9-]/g, '');
    inputElement.value = validInput;
    if (this.row) {
      this.row.batch_no = validInput;
    }
  }

  getCurrentDateTime() {
    const currentDate = new Date();
  
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
  }

  openDeleteModal(template: TemplateRef<any>, id?) {
    this.modalRefDelete = this.modalService.show(template, { class: 'modal-md' });
  }
  
  deleteBatch() {
    this.loader.showLoader();
    this.categoryService.deleteBatch('batch-uuid')
      .pipe(first())
      .subscribe(
        data => {
          this.loader.hideLoader();
          if (data.meta.status === true) {
            this.modalRefDelete.hide();
            this.toast.success(data.meta.message);
            this.rerender(false);
          }
        },
        error => {
          this.loader.hideLoader();
          const statusError = error;
          if (statusError && statusError.meta) {
            this.toast.error(statusError.meta.message);
            this.modalRefDelete.hide();
            this.rerender(false);
          } else {
            this.toast.error('Something went wrong please try again.');
          }
        });
  }

  
}
